import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Permissions } from 'src/app/core/enums/permissions.enum'

@Component({
  selector: 'app-simulation-view-actions-bar',
  templateUrl: './simulation-view-actions-bar.component.html',
  styleUrls: ['./simulation-view-actions-bar.component.scss'],
  standalone: false,
})
export class SimulationViewActionsBarComponent {
  public readonly Permissions = Permissions

  @Input() public isHexagonWarningCreationVisible = false
  @Input() public isRoadWarningCreationVisible = false
  @Input() public isSimulationEditorVisible = false
  @Input() public highlightNewEditor = false

  @Output() public toggleHexagonWarning = new EventEmitter<void>()
  @Output() public toggleRoadWarning = new EventEmitter<void>()
  @Output() public toggleEditor = new EventEmitter<void>()
}
